export enum InitialOrderModalMode {
  VIEW,
  SUGGEST
}

export enum FinalOrderModalMode {
  VIEW,
  INPUT
}
